export default {
  'clocks': [],
  'permanentRequiredFields': [
    'RequestInterest',
    'Salutation',
    'FirstName',
    'LastName',
    'Email'
  ],
  'requiredFields': {
    'default': [
      'Company',
      'PostalCode',
      'CompanyRegistrationNo'
    ],
    'consulting': [
      'Company',
      'RequestTopic',
      'PostalCode',
      'CompanyRegistrationNo'
    ],
    'offersGeneral': [
      'Company',
      'RequestTopic',
      'PostalCode',
      'CompanyRegistrationNo'
    ],
    'customer_serviceGeneral': [
      'Company',
      'RequestTopic',
      'PostalCode',
      'CompanyRegistrationNo'
    ],
    'investor_relations': [
      'Company',
      'RequestTopic',
      'PostalCode'
    ],
    'cooperation': [
      'Company',
      'RequestTopic',
      'PostalCode'
    ],
    'career': [
      'RequestMessage',
    ],
    'press': [
      'RequestMessage'
    ]
  }
}
